export default __webpack_public_path__ + "static/media/image_wwm (3).e2825ecf.png";